import api from "@/services/api";

export default {
  refreshtoken() {
    return api().get("empresa/refresh/");
  }
};
